'use es6';

import { getActiveAssetId } from 'DesignData/selectors/app';
import { makeGetEditorErrorData } from 'DesignData/selectors/statusBar';
const getEditorErrorData = makeGetEditorErrorData();
export function mapStateToProps(state) {
  const props = {
    assetId: getActiveAssetId(state)
  };
  const editorErrorData = getEditorErrorData(state, props);
  return editorErrorData;
}